import * as sdk from "@visonum/network-quality-sdk";
import * as rxjs from "rxjs";

export const createNetworkQualityImpl = sdk.createNetworkQuality;

export const measurementModes = {
  production: sdk.MeasurementMode.Production,
  customer_Sat: sdk.MeasurementMode.Customer_Sat,
  wait_For_Prepare: sdk.MeasurementMode.Wait_For_Prepare,
  error_On_Modem_Customer_NonSat_ModemAvailable:
    sdk.MeasurementMode.Error_On_Modem_Customer_NonSat_ModemAvailable,
  error_Too_High_Results: sdk.MeasurementMode.Error_Too_High_Results,
  error_Unconnected: sdk.MeasurementMode.Error_Unconnected,
  error_Ping_No_Intermediate_Values: sdk.MeasurementMode.Error_Ping_No_Intermediate_Values,
  customer_NonSat_ModemNotAvailableDCA: sdk.MeasurementMode.Customer_NonSat_ModemNotAvailableDCA,
  customer_NonSat_ModemAvailable: sdk.MeasurementMode.Customer_NonSat_ModemAvailable,
  customer_NonSat_ModemFailed: sdk.MeasurementMode.Customer_NonSat_ModemFailed
};

export const getLoggerImpl = sdk.getLogger;
export const loggerLevels = {
  fatal: "fatal",
  error: "error",
  warn: "warn",
  info: "info",
  debug: "debug",
  trace: "trace",
  silent: "silent",
};


export function prepareImpl(sdkInstance, options) {
  try {
    return sdkInstance.prepare(options);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function abortImpl(sdkInstance, prepareResult) {
  try {
    return sdkInstance.abort(prepareResult);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function calcDownloadImpl(sdkInstance, data) {
  try {
    return sdkInstance.calcDownload(data);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function calcUploadImpl(sdkInstance, data) {
  try {
    return sdkInstance.calcUpload(data);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function benchmarkImpl(sdkInstance, prepareResult) {
  try {
    return sdkInstance.benchmark(prepareResult);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function pingImpl(sdkInstance, prepareResult) {
  try {
    return sdkInstance.ping(prepareResult);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function modemImpl(sdkInstance, prepareResult) {
  try {
    return sdkInstance.modem(prepareResult);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}

export function completeImpl(sdkInstance, prepareResult) {
  try {
    return sdkInstance.complete(prepareResult);
  } catch (err) {
    return rxjs.throwError(() => err);
  }
}
